// AuthContext.js

import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [openLogin, setOpenLogin] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  // const [ppUrl, setPPUrl] = useState("");

  const loginUser = (token, userDetails = {}) => {
    Cookies.set("accessToken", token);
    // Cookies.set("userEmail", email);
    // Cookies.set("userFirstName", firstName);
    // Cookies.set("userLastName", lastName);
    // Cookies.set("userPhotoUrl", photoUrl);
    // console.log("about to set userDetails: ", userDetails);
    Cookies.set("userDetails", JSON.stringify(userDetails));

    setAccessToken(token);
    setUserDetails(userDetails);
    // setPPUrl(photo_url);
  };

  const logoutUser = () => {
    Cookies.remove("accessToken");
    // Cookies.remove("userEmail");
    // Cookies.remove("userFirstName");
    // Cookies.remove("userLastName");
    // Cookies.remove("userPhotoUrl");
    Cookies.remove("userDetails");

    setAccessToken("");
    setUserDetails(null);
    // setPPUrl("");
  };

  const updateProfilePic = (photoUrl = null) => {
    // console.log("called updateprofilepic");
    if (userDetails) {
      // console.log("userDetails inside: ", userDetails);
      const updatedUserDetails = {
        ...userDetails,
        photoUrl: photoUrl, // Update profilePic property
      };

      // Update state and cookie with the new profile picture
      setUserDetails(updatedUserDetails);
      Cookies.set("userDetails", JSON.stringify(updatedUserDetails));
    }
  };

  const showLoginModal = () => {
    setOpenLogin(true);
  };

  const closeLoginModal = () => {
    setOpenLogin(false);
  };

  const value = {
    accessToken,
    userDetails,
    loginUser,
    logoutUser,
    openLogin,
    showLoginModal,
    closeLoginModal,
    updateProfilePic,
  };

  // check if the token exists for the first time
  useEffect(() => {
    var token = Cookies.get("accessToken");
    const storedUserDetails = Cookies.get("userDetails");

    // console.log("@@@ token: ", token);
    if (token) {
      setAccessToken(token);
    }

    if (storedUserDetails) {
      try {
        const parsedUserDetails = JSON.parse(storedUserDetails); // Parse the stored JSON string
        setUserDetails(parsedUserDetails);
      } catch (error) {
        console.error("Error parsing user details from cookie:", error);
      }
    }

    return () => {};
  }, []);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
